export default {
  website: {
    shoutoutSliderText1:
      'Stream wedstrijden uit Ligue 1, Serie A, Bundesliga, Premier League, NFL, NBA, NCAA en nog veel meer!',
    'shoutout!': 'Shoutout!',
    loveTheGame: 'HOU VAN HET SPEL. MAAK HET JE EIGEN.',
    joinTheDedicated:
      'Word lid van het speciale sociale sportnetwerk - een ecosysteem dat sterker is met sponsors en partners.',
    aSportsCommunity: 'Een marktplaats voor sportgemeenschappen.',
    athletesMonetize: 'Atleten verdienen geld aan hun merk en zichzelf!',
    fansConnectDirectly: 'Fans komen rechtstreeks in contact met atleten.',
    ledByAthletes: 'GELEID DOOR ATLETEN.',
    ledByFans: 'ONDER LEIDING VAN FANS.',
    ledBy: 'GELEID DOOR',
    'athletes.': 'ATLETEN.',
    'fans.': 'FANS.',
    goToApp: 'Ga naar de app',
    logout: 'Afmelden',
    amAnAthlete: 'Ik ben een atleet',
    monetizeYourBrand:
      'Verdien geld met je eigen persoonlijke merk door een unieke wereld te creëren met je fans.',
    amAFan: 'Ik ben een fan',
    connectDirectlyWith: 'Maak rechtstreeks contact met je favoriete atleten en andere fans.',
    athleteZone: 'ATLETENZONE',
    fanZone: 'FAN ZONE',
    ourAthletes: 'ONZE ATLETEN',
    news: 'Nieuws',
    ourStory: 'ONS VERHAAL',
    sponsors: 'SPONSOREN',
    contact: 'CONTACT',
    athleteFocus: 'Atleet focus',
    calculator: 'Rekenmachine',
    seeHowMuch: 'Kijk hoeveel je merk je kan opleveren.',
    weAllPlay: 'SPELEN WE ALLEMAAL BETER SAMEN.',
    everybody: 'IEDEREEN',
    playsBetter: 'SPEELT BETER',
    weAll: 'WIJ ALLEN',
    playBetter: 'SPEELT BETER',
    together: 'SAMEN.',
    video: 'Video',
    tiffanyVan: 'Tiffany Van Soest',
    goto: 'Ga naar',
    athleteZoneSmall: 'Atletenzone',
    latestNews: 'LAATSTE NIEUWS',
    ledByPartners: 'GELEID DOOR PARTNERS.',
    partnersAndSponsors: 'Partners en sponsoren',
    ledByTeams: 'GELEID DOOR TEAMS.',
    seeOurWork: 'Bekijk ons werk met deze topsporters',
    sportsCareer:
      'Sportcarrières kunnen kort zijn, maar je hebt een leven lang ervaring opgedaan. Nu is het tijd om de vruchten te plukken..,',
    buildAnOngoing: 'Een duurzaam inkomen opbouwen..,',
    takeControl: 'Neem de controle over je merk - en je toekomst, JEZELF',
    signUpForFree: 'Meld je gratis aan om te berekenen hoeveel je carrière je kan blijven geven.,',
    'connect!': 'Verbinden!',
    unlimitedAccess:
      'Onbeperkte toegang tot je favoriete atleten. Bouw je eigen netwerk van sporthelden!',
    'stream!': 'Stream!',
    streamGamesFrom:
      'Stream wedstrijden uit Ligue 1, Serie A, Bundesliga, Premier League, NFL, NBA, NCAA en nog veel meer!',
    stayVisible: 'BLIJF ZICHTBAAR.',
    connectWithUs: 'Maak contact met ons',
    newsletter: 'Nieuwsbrief',
    typeEmail: 'Typ hier e-mail en druk op enter',
    typeAndEnter: 'Type e-mail hier en druk op enter',
    wedLoveTo: 'We horen graag van je.',
    sendUsAMessage: 'Stuur ons een bericht',
    notAnAthleteOrFan: 'Geen atleet of fan?',
    connectWithUsHere: 'Kom toch met ons in contact!',
    home: 'Home',
    fanZoneSmall: 'Fanzone',
    ourStorySmall: 'Ons verhaal',
    ourAthletesSmall: 'Onze atleten',
    selectCountry: 'Selecteer land',
    signUp: 'Aanmelden',
    stopTheHate: 'Stop haat.',
    termsAndConditions: 'Voorwaarden',
    privacyPolicy: 'Privacybeleid',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'Alle rechten voorbehouden',
    led: 'GELEID DOOR',
    byTopAthletes: 'DOOR TOPATLETEN',
    partners: 'Partners',
    investors: 'Investeerders',
    attendees: 'Deelnemers',
    date: '26-29 april',
    location: 'Wesley Chapel, Florida',
    dontMiss: 'NIET MISSEN',
    outOn: 'UIT OP',
    your: 'JOUW',
    timeToShine: 'TIJD OM TE SCHITTEREN.',
    registerForCombine: 'Schrijf je in voor Combineren',
    registrationEnds: 'DE INSCHRIJVING EINDIGT',
    days: 'Dagen',
    hours: 'Uren',
    minutes: 'Minuten',
    seconds: 'Seconden',
    ourPartners: 'ONZE PARTNERS.',
    enjoyTheseMembership: 'Geniet van deze geweldige lidmaatschapsonderdelen',
    sportUnites: 'SPORT VERENIGT.',
    noDivide: 'GEEN VERDELING.',
    videosArticles: "Video's, artikelen en interviews met sportsterren",
    instantMessaging: 'Instant messaging met je favoriete atleten',
    discountOnEvent: 'Kortingen op evenementtickets en merchandise',
    behindTheScenes: 'Achter de schermen toegang tot de sportwereld',
    experienceSport: 'SPORT BELEVEN ZOALS JIJ HET GRAAG DOET.',
    theOnlySportsApp:
      'De enige sport app die je direct in contact brenht met je favoriete atleten - in real time!',
    buildYourOwnWorld:
      'Bouw je eigen wereld op door rechtstreeks contact te leggen met atleten - het echte werk.',
    chooseTheFeatures: 'Kies de functies waar je van houdt.',
    interactWithAthletes: 'Interactie met atleten - en laat je inspireren!',
    sendAShoutout:
      'Stuur een shoutout naar je sporter of team vlak voor – of zelfs tijdens – de wedstrijd!',
    fanLife: '#FANLIFE',
    highlights: 'Hoogtepunten',
    recentArticles: 'Recente artikelen',
    p4pxIra: 'p4p x Ira Brown',
    uploadedDate: 'Geüpload op 28 februari 2022',
    youMightAlso: 'Misschien vind je het ook leuk...',
    'subscribe!': 'Abonneren!',
    getContent:
      ' Ontvang inhoud en streaming voor uw favoriete sport - of alle sporten op playaz4playaz!',
    'vipConnects!': 'VIP Connects!',
    '1-to-1connections': '1-op-1 verbindingen met uw favoriete atleet, virtueel of persoonlijk!',
    watch: 'Bekijk: het p4p-verhaal',
    caseStudies: 'Praktijkvoorbeelden',
    aboutHenrySeals:
      'Henry is afgestudeerd aan Harvard University en is een ervaren people leader. Momenteel is Henry de CHRO voor Zaiko, een in Japan gevestigde startup die makers ondersteunt bij het betrekken van hun fans via digitale en hybride betrokkenheid.  Hij is ook de eerste in het buitenland geboren mensenrechtencommissaris van Japan en de oprichter van de Legacy Foundation Japan. \u000bAls CHRO voor Paidy hielp hij hen een van Japans enige unicorns (bedrijven met een waarde van miljarden dollars) te worden en in 2021 naar de beurs te gaan.\nHij heeft ook senior HR-functies bekleed voor Philip Morris International, AIG en NN.\n\n',
    aboutHoustonRoss:
      'Houston heeft jarenlange ervaring in het leiden van wereldwijde organisaties bij het voorbereiden op de toekomst, het moderniseren van operaties en infrastructuur, en het ontwikkelen van teams om op hoog niveau te presteren.  Meest recentelijk was Houston de CTO voor de Japanse BNPL-unicorn Paidy, die de organisatie naar een succesvolle publieke exit leidde.\nAls wereldwijd leider heeft Houston de rol van CTO vervuld voor wereldwijde financiële organisaties zoals AXA Life, ING en NN.  \nAls sportliefhebber wil hij zijn ervaring op het gebied van technologie, financiën en operational excellence inzetten om van P4P een wereldleider te maken.',
    aboutJuliusGoldsmith:
      "Julius is een advocaat met meer dan 20 jaar Wall St. ervaring op het gebied van Business Development, New Product Development en grensoverschrijdende transacties. Julius heeft gewerkt in New York City, Londen, Singapore en Tokio, waar hij uitgebreide ervaring heeft opgedaan in verschillende disciplines, waaronder bedrijfsontwikkeling, financiën, juridische en fiscale zaken.  Julius is lid van de Dean's Advisors van het Silberman College of Business aan de Fairleigh Dickinson University (zijn alma mater) en heeft ook een CPA.  ",
    aboutMarcelVanDruten:
      "Marcel Van Druten is een doorgewinterde professional met een bewezen staat van dienst in tech-industrie. \nGeboren en getogen in Amsterdam, Nederland, speelde Marcel tot de leeftijd van 21 jaar actief voetbal als een onverschrokken verdediger in de hoogste amateurcompetities bij verschillende voetbalclubs. \nDankzij zijn diepgaande marketing- en commerciele -expertise heeft Marcel wereldwijde merken geholpen bij het ontwikkelen en implementeren van programma's en initiatieven om de omzet te verhogen en de merkbekendheid te vergroten. Meertalig in Engels, Nederlands en Duits, en met een grote passie voor vechtsporten, golf en formule 1, helpt Marcel P4P om de beste Sport App ter wereld te worden.\n",
    aboutMichaelAJacobs:
      'Michael is een senior executive en juridische professional met een gevarieerde staat van dienst in het verbeteren van operaties op meerdere locaties door superieure betrokkenheid van de gemeenschap; personeelszaken; arbeids- en werknemersrelaties en juridische ervaring. Momenteel is hij hoofddocent aan de New York University, Robert F. Wagner Graduate School of Public Service en Adjunct Associate Professor aan The City University of New York, School of Professional Studies. Michael was eerder adjunct-faculteitslid aan de University of Maryland Global Campus (voorheen University of Maryland University College) en Howard University School of Law.\n',
    aboutMichaelJackson:
      'Michael is afgestudeerd aan de Columbia University en is een ervaren productmanager en voormalig regionaal hoofd levering voor wereldwijde vermogens- en vermogensbeheerorganisaties. Hij heeft jarenlange ervaring met het leveren van wereldwijde projecten gericht op het verbeteren van de operationele efficiëntie en het leveren van diensten\/producten. \n\n',
    sponsorsSmall: 'Sponsors',
    becomeASponsor: 'SPONSOR WORDEN VAN P4P',
    content1: 'Lorem ipsum...',
    content2: 'Lorem ipsum...',
    ourTeams: 'ONZE TEAMS.',
    paymentDetails: 'BETALINGSGEGEVENS',
    cancelWithin30Days:
      'Annuleer binnen 30 dagen en je kaart wordt niet belast. Je hebt nog steeds toegang tot basisfuncties.',
    cardNumber: 'KAARTNUMMER',
    expiry: 'VERVAL',
    cvc: 'CVC',
    illDoItLater: 'Ik zal het later doen.',
    submit: 'Indienen',
    athleteInformation: 'ATLEET INFORMATIE',
    contactInformation: 'CONTACTINFORMATIE',
    otherInformation: 'ANDERE INFORMATIE',
    dateOfBirth: 'GEBOORTEDATUM',
    year: 'Jaar',
    month: 'Maand',
    day: 'Dag',
    socialNetworks: 'SOCIALE NETWERKEN',
    Instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    uploadHeadshot: 'Upload hoofdfoto of foto van basketbalactie',
    phoneNumber: 'Telefoonnummer',
    sport: 'Sport',
    linkInstagram: 'Link naar je Instagram-profiel',
    linkFacebook: 'Link naar je Facebook-profiel',
    linkTwitter: 'Link naar je Twitter-profiel',
    athleteSignUp: 'atleet Aanmelden',
    thankYou: 'BEDANKT',
    youWillBeSent: 'Je ontvangt binnenkort een e-mailbevestiging.',
    getTheApp: 'GET DE APP!',
    or: 'OF',
    continueOnWebsite: 'Ga verder op website',
    welcome: 'WELKOM!',
    '30dayFull': '30 dagen volledige toegang!',
    enjoyTheseAmazing: 'Geniet gratis en vrijblijvend van deze geweldige functies!',
    yesGiveMe: 'Ja, geef mij gratis toegang!',
    noThanksKeep: 'Nee bedankt, hou het basic',
    letsWorkTogether: 'Laten we samenwerken! Vul je gegevens in en wij nemen contact  op.',
    yourDetails: 'JOUW DETAILS',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    emailAddress: 'E-mailadres',
    companyInformation: 'BEDRIJFSINFORMATIE',
    companyName: 'Bedrijfsnaam',
    companyWebsite: 'Website van het bedrijf',
    login: 'Inloggen',
    getApp: 'verkrijg de app',
    letsTalk: 'Laten we praten',
    sponsor: 'Sponsor',
    useTheApp: 'Gebruik de APP',
    messageSent: 'Bericht succesvol verzonden.',
    invalidEmail: 'E-mail ongeldig.',
    addedToNewsletter: 'E-mail succesvol toegevoegd aan nieuwsbrief.',
    recently: 'Onlangs',
    aboutAyannaColeman: 'Lorem ipsum...'
  }
};
